import PropTypes from 'prop-types';
import React from 'react';
import RouterLink from 'react-router/lib/Link';
import withRouter from 'react-router/lib/withRouter';
import { routerShape } from 'react-router/lib/PropTypes';

import urls from '../../urls';

function Link ({ to, params, query, absolute, tabIndex, srOnly, router, ...restProps}) {
    const expectedTabIndex = restProps.disabled ? -1 : tabIndex;
    if (urls.hasMatchingRoute(to) && !absolute) {
        const location = urls.location(to, params, query);
        const isCurrent = router && router.isActive(location);
        return (
            <RouterLink
                to={ location }
                activeClassName="active"
                tabIndex={ expectedTabIndex }
                aria-current={isCurrent ? 'page' : null}
                { ...restProps }
            >
                { srOnly && <span className="sr-only">{ srOnly }</span> }
                { restProps.children }
            </RouterLink>
        );
    } else {
        const url = urls.getUrl(to, params, query);
        return (<a href={ url } { ...restProps } tabIndex={ expectedTabIndex }>
                    { srOnly && <span className="sr-only">{ srOnly }</span> }
                    { restProps.children }</a>);
    }
}

Link.propTypes = {
    to: PropTypes.string.isRequired,
    params: PropTypes.object,
    query: PropTypes.object,
    absolute: PropTypes.bool,
    tabIndex: PropTypes.string,
    router: routerShape,
    srOnly: PropTypes.string
};

Link.defaultProps = {
    params: null,
    query: null,
    absolute: false,
    tabIndex: "0",
    srOnly: ''
};

export default withRouter(Link);
